<template>
	<div class="radio-field">
		<div
				v-if="label"
				:class="['labelClone', { 'text-error': hasError }]"
		>
			{{ label }}
		</div>

		<v-radio-group
				v-model="internalValue"
				:dense="dense"
				:row="row"
				:error-messages="computedErrorMessages"
				class="no-margin"
		>
			<v-radio
					v-for="item in items"
					:key="item[valueKey]"
					class="request"
					:label="item[labelKey]"
					:value="item[valueKey]"
			/>
		</v-radio-group>
	</div>
</template>

<script>
export default {
	name: 'RadioField',

	props: {
		/** значение для v-model */
		value: {
			type: [ String, Number, Boolean, null ],
			default: null
		},

		/** список радио-кнопок */
		items: {
			type: Array,
			required: true
		},

		/** текст заголовка над радиокнопками */
		label: {
			type: String,
			default: ''
		},

		/** текст ошибки по умолчанию (если валидатор вернул $error) */
		errorText: {
			type: String,
			default: 'Please select option'
		},

		/** объект валидации Vuelidate для этого поля ($v.request_id) */
		validation: {
			type: Object,
			default: null
		},

		/** ключ для label в items */
		labelKey: {
			type: String,
			default: 'name'
		},

		/** ключ для value в items */
		valueKey: {
			type: String,
			default: 'id'
		},

		/** в строку или в колонку */
		row: {
			type: Boolean,
			default: true
		},

		/** dense стиль */
		dense: {
			type: Boolean,
			default: true
		},

		/** кастомные сообщения об ошибке (если нужно вручную) */
		errorMessages: {
			type: Array,
			default() {
				return [];
			}
		}
	},

	computed: {
		internalValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val);
			}
		},

		hasError() {
			return this.validation ? this.validation.$error === true : false;
		},

		computedErrorMessages() {
			// если передали свои errorMessages — используем их
			if (this.errorMessages && this.errorMessages.length) {
				return this.errorMessages;
			}

			// если есть Vuelidate-ошибка — показываем текст ошибки
			if (this.hasError) {
				return [ this.errorText ];
			}

			return [];
		}
	}
};
</script>

<style scoped lang="scss">
.radio-field {
	.v-input--selection-controls {
		margin-top: 0;
	}
	.labelClone {
		font-weight: 500;
		font-size: 12px;
		line-height: 16px;
		letter-spacing: 0.25px;
		color: var(--field-label);
		text-align: left;
		&:after {
			content: "*";
			color: red;
		}
		&.text-error {
			color: var(--field-red);
		}
	}
	.no-margin {
		margin-top: 0 !important;
	}
}

</style>
